import React from 'react';
import { useCurrency } from '../context/CurrencyContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

const CurrencySelector = ({ className = '' }) => {
  const { currency, changeCurrency, currencies } = useCurrency();

  const currencyInfo = {
    GBP: { flag: '🇬🇧', name: 'GBP (£)' },
    EUR: { flag: '🇪🇺', name: 'EUR (€)' },
    USD: { flag: '🇺🇸', name: 'USD ($)' }
  };

  return (
    <Select value={currency} onValueChange={changeCurrency}>
      <SelectTrigger className={`w-[100px] h-8 text-xs ${className}`} data-testid="currency-selector">
        <SelectValue>
          {currencyInfo[currency]?.flag} {currency}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {currencies.map((curr) => (
          <SelectItem key={curr} value={curr} data-testid={`currency-option-${curr}`}>
            <span className="flex items-center gap-2">
              {currencyInfo[curr]?.flag} {currencyInfo[curr]?.name}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
